import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class LandOwnershipTypesApi extends ApiModule {
	constructor() {
		super(ModulesMap.LAND_OWNERSHIP_TYPES, {
			entity: 'land_ownership_types',
		})
	}
}
